import React from 'react'
import { usePhotoAPIContext } from '../../../contexts/photoContext'

const PhotoValue = ({ entry }) => {
  const { updateOpenIndex } = usePhotoAPIContext()

  return (
    <div className='grid grid-cols-3 gap-x-1 mr-2'>
      {!!entry?.value && <img
        alt={entry.value}
        src={`/mobile-record-images/${entry.id}`}
        onClick={() => updateOpenIndex(entry.value)}
        className="cursor-pointer"
      />}
      {!entry?.value && (<>&nbsp;</>)}
    </div>
  )
}

export default PhotoValue

